import seatAdapter from '@/adapters/seat';

export default (el) => ({
  id: String(el.id),
  date: new Date(el.date),
  schemeId: String(el.hall_scheme_id),
  performanceId: String(el.performance_id),
  availableSeats: (el.available_seats || []).map(seatAdapter),
});
